module.exports = __webpack_public_path__ + "static/media/personPlaceholder.6a77698a.jpg";